module.exports = __webpack_public_path__ + "img/03.31d57701.png";